import { allEnumValues, BiteLogType } from '@biteinc/enums';
export const biteLogSchema = {
    displayName: 'log',
    type: 'object',
    fields: {
        clientId: {
            type: 'mongoId',
            required: true,
        },
        clientName: {
            type: 'shortString',
            required: true,
        },
        kioskId: {
            type: 'mongoId',
        },
        createdAt: {
            type: 'timestamp',
            required: true,
            isPermanent: true,
        },
        isFinalError: {
            type: 'bool',
        },
        attemptNumber: {
            type: 'int',
        },
        error: {
            type: 'longString',
        },
        message: {
            type: 'longString',
        },
        type: {
            type: 'int',
            values: allEnumValues(BiteLogType),
            required: true,
        },
        macAddress: {
            type: 'shortString',
        },
        status: {
            type: 'int',
        },
        prevStatus: {
            type: 'int',
        },
        systemCode: {
            type: 'int',
        },
        duration: {
            type: 'int',
            max: 1900000000000,
            // 'increasing the max to 2030-03-17 because BITE-715 happens'
        },
        userId: {
            type: 'mongoId',
        },
        username: {
            type: 'shortString',
        },
        gazeboConfigDiff: {
            type: 'object',
            isFreeform: true,
        },
        gcnCrashReport: {
            type: 'object',
            isFreeform: true,
        },
        stats: {
            type: 'object',
            isFreeform: true,
        },
        json: {
            type: 'object',
            isFreeform: true,
        },
        state: {
            type: 'int',
        },
        updateState: {
            type: 'int',
        },
        transactionStep: {
            type: 'int',
        },
        clientPrintState: {
            type: 'int',
            // TODO: 'remove this when everyone is on v2.62'
        },
        receiptPrintState: {
            type: 'int',
        },
        logs: {
            type: 'codeString',
        },
        screenshotUrl: {
            type: 'shortString',
        },
        screenshotData: {
            type: 'longString',
        },
        sentryEventId: {
            type: 'shortString',
        },
        url: {
            type: 'keyString',
            isReadOnly: true,
        },
        locationIntegrationSystems: {
            type: 'array',
            elementType: 'int',
            displayName: 'Integration Systems',
            isReadOnly: true,
        },
        orderId: {
            type: 'mongoId',
        },
        clientOrderId: {
            type: 'mongoId',
        },
    },
};
//# sourceMappingURL=bite_log_schema.js.map